import constants from '../constants';
import swaggerSpec from '../swagger.json';

const INVOKE_URL = constants.AWS_APIGW_INVOKE_URL;

class SwaggerSpec {
  constructor() {
    this.spec = swaggerSpec;
    if (INVOKE_URL !== undefined) {
      const { host, pathname } = new URL(INVOKE_URL);
      this.spec = {...this.spec, host, basePath: pathname};
    }
  }
}

export default SwaggerSpec;



// WEBPACK FOOTER //
// ./src/classes/SwaggerSpec.js